export const getHasHeroImage = heroImage => !!heroImage?.url ?? false;
